import type { IContentInfo, VideoSourceInfo } from '@setplex/tria-api'
import { createEvent } from 'effector'

export const play = createEvent<VideoSourceInfo>()
export const stop = createEvent<VideoSourceInfo>()
export const watchingContent = createEvent<IContentInfo>()
